import React from "react";
import styled from "styled-components";
import PlayCatalog from "sections/PlayCatalog";
import WithAuth from "../containers/WithAuth";
import QuickerClipDialog from "../components/QuickerClipDialog";

const Page = styled.div`
  height: 100vh;
`;

class VideoEditor extends React.PureComponent {
  render() {
    return (
      <Page>
        <PlayCatalog />
        <QuickerClipDialog />
      </Page>
    );
  }
}

export default WithAuth(VideoEditor);



// WEBPACK FOOTER //
// ./src/pages/VideoEditor.js